<template>
    <div id="contenedor-main-listado-sub-tipos-obra">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :listadoSubTiposObras="listadoSubTiposObras"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoSubTiposObras="listadoSubTiposObras"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoSubTiposObra',
  props: {
    listadoSubTiposObras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
